'use strict';

var parser = require('./pegjs/actions-parser');
var _ = require('lodash');
var ActionSerializerService = function ActionSerializerService(strategyRecordService, ActionQuery, StrategyAction, StrategyConstants) {
  var type = StrategyConstants.ACTION;
  function isComboboxObject(val) {
    return _.isObject(val) && _.has(val, 'value');
  }
  function parseRtpValue(value) {
    return parseInt(value.split('d')[0]);
  }
  function buildRtpValue(value) {
    return value + 'd 0h 0m';
  }
  function buildRangeBelowValue(val) {
    return 0 - val;
  }

  /**
   * If the value is an object reads its value.
   * Returns the value otherwise.
   * @param val
   * @returns {*}
   */
  function getValueFromObject(val) {
    if (isComboboxObject(val)) {
      return val.value;
    }
    return val;
  }
  function serialize(level, entityType, action) {
    var serializedAction = [];
    var actionQuery = new ActionQuery().action(action.action);
    var argsNo = strategyRecordService.getArgsNo(type, level, entityType, action.category, action.criterion, action.action) || '1';
    if (action.field === 'demand.remainingDemandFC') {
      var endRtpValid = action.secondValue || action.secondValue === 0;
      var startRtpValid = action.thirdValue || action.thirdValue === 0;
      var rtpActionQuery = new ActionQuery().action('Set');
      actionQuery.value(getValueFromObject(action.value));
      actionQuery.field(action.field);
      serializedAction.push(actionQuery.query());
      if (getValueFromObject(action.value) !== null) {
        var startRtpValue = startRtpValid ? action.thirdValue : 400;
        rtpActionQuery.value(buildRtpValue(startRtpValue));
        rtpActionQuery.field('startRtp');
        serializedAction.push(rtpActionQuery.query());
      }
      if (endRtpValid && startRtpValid) {
        rtpActionQuery.value(buildRtpValue(action.secondValue));
        rtpActionQuery.field('endRtp');
        serializedAction.push(rtpActionQuery.query());
      }
    } else if (action.field === 'competitorFareInfo.rangeBelow') {
      actionQuery.value(buildRangeBelowValue(action.value));
      actionQuery.field(action.field);
      serializedAction.push(actionQuery.query());
    } else if (action.field === 'competitorFareInfo.classNames') {
      actionQuery.value(_.join(action.value, ','));
      actionQuery.field(action.field);
      serializedAction.push(actionQuery.query());
    } else if (argsNo === '1') {
      if (action.criteriaType || action.criteriaType === 0) {
        actionQuery.value(getValueFromObject(action.criteriaType));
        actionQuery.field(action.field[0]);
        serializedAction.push(actionQuery.query());
        if (action.field[1] === 'segmentLimitResSys' && action.value === null) {
          actionQuery.value(999);
        } else {
          actionQuery.value(getValueFromObject(action.value));
        }
        actionQuery.field(action.field[1]);
        serializedAction.push(actionQuery.query());
      } else {
        actionQuery.value(getValueFromObject(action.value));
        actionQuery.field(action.field);
        serializedAction.push(actionQuery.query());
      }
    } else {
      if (action.criteriaType || action.criteriaType === 0) {
        actionQuery.value(action.criteriaType);
        actionQuery.field(action.field[0]);
        serializedAction.push(actionQuery.query());
        actionQuery.value(getValueFromObject(action.value));
        actionQuery.field(action.field[1]);
        serializedAction.push(actionQuery.query());
        actionQuery.value(getValueFromObject(action.secondValue));
        actionQuery.field(action.field[2]);
        serializedAction.push(actionQuery.query());
      } else {
        actionQuery.value(getValueFromObject(action.value));
        actionQuery.field(action.field[0]);
        serializedAction.push(actionQuery.query());
        actionQuery.value(getValueFromObject(action.secondValue));
        actionQuery.field(action.field[1]);
        serializedAction.push(actionQuery.query());
      }
    }
    return serializedAction;
  }
  function parseAction(validOptions, option, percent) {
    if (validOptions.indexOf(option) === -1) {
      var suffix = percent ? ' (%)' : ' (Abs)';
      var newOption = option + suffix;
      if (validOptions.indexOf(newOption) !== -1) {
        return newOption;
      }
    }
    return option;
  }
  function getCriteriaType(actionData) {
    if (actionData.criteriaType) {
      if (isComboboxObject(actionData.criteriaType)) {
        return actionData.criteriaType;
      }
      return actionData.criteriaType.fieldValue;
    }
    return null;
  }
  function createStrategyAction(level, entityType, action, actionData) {
    var validOptions = strategyRecordService.getActions(type, level, entityType, actionData.category, actionData.criteria);
    var option = actionData.option || action.option;
    var percent = actionData.percent || action.percent;
    var parsedAction = parseAction(validOptions, option, percent);
    var fieldType = strategyRecordService.getValueType(type, level, entityType, actionData.category, actionData.criteria, option);
    return new StrategyAction({
      category: actionData.category,
      criterion: actionData.criteria,
      field: actionData.field,
      level: level,
      action: parsedAction,
      value: actionData.value,
      secondValue: actionData.secondValue,
      thirdValue: actionData.thirdValue,
      criteriaType: getCriteriaType(actionData),
      argsNo: strategyRecordService.getArgsNo(type, level, entityType, actionData.category, actionData.criteria, parsedAction),
      fieldType: fieldType
    });
  }
  function parse(input) {
    return parser.parse(input);
  }

  /**
   * For comboboxes, tries to find an object associated with a given value read from a server.
   * Returns the value otherwise.
   * @param availableValues
   * @param value
   * @returns {*}
   */
  function getObjectFromValue(availableValues, value) {
    if (availableValues && availableValues.length > 0 && isComboboxObject(availableValues[0])) {
      return _.find(availableValues, ['value', value]);
    }
    return value;
  }
  function setActionValue(currentAction, availableValues, parsedAction) {
    if (currentAction.value || currentAction.value === 0) {
      var newValue = getObjectFromValue(availableValues, parsedAction.value);
      if (parsedAction.property === 'endRtp') {
        currentAction.secondValue = parseRtpValue(newValue);
      } else if (parsedAction.property === 'startRtp') {
        currentAction.thirdValue = parseRtpValue(newValue);
      } else {
        currentAction.secondValue = newValue;
      }
    } else {
      currentAction.value = getObjectFromValue(availableValues, parsedAction.value);
    }
  }
  function isUserInputtedCriteriaType(parsedAction, criteriaTypeConfig) {
    return criteriaTypeConfig && parsedAction.property === criteriaTypeConfig.fieldName && criteriaTypeConfig.userInputted;
  }
  function deserialize(statement, entityType) {
    var level = statement.level;
    var deserializedActions = [];
    var actionFields = [];
    var currentAction, availableValues, currentActionCriteriaTypeConfig;
    statement.actions.forEach(function (action) {
      if (action) {
        var connectedFields;
        if (action.includes('segmentLimitResSys') && action.includes('999')) {
          action = action.replace('999', 'null');
        }
        var parsedAction = parse(action);
        var actionId = actionFields.indexOf(parsedAction.property);
        if (actionId === -1 && parsedAction.property !== 'startRtp' && parsedAction.property !== 'endRtp') {
          currentAction = _.first(strategyRecordService.getCategoryCriteriaForField(type, level, entityType, undefined, parsedAction.property, parsedAction.value));
          currentActionCriteriaTypeConfig = currentAction.criteriaType;
          availableValues = strategyRecordService.getAvailableValues(type, level, entityType, currentAction.category, currentAction.criteria, parsedAction.option);
          connectedFields = strategyRecordService.getConnectedFields(type, level, entityType, currentAction.category, currentAction.criteria);
          actionFields = actionFields.concat(connectedFields);
          currentAction.field = connectedFields;
          if (currentAction.field === 'demand.remainingDemandFC' && !parsedAction.percent && parsedAction.option !== 'Remove') {
            actionFields = actionFields.concat(['startRtp', 'endRtp']);
            currentAction.option = parsedAction.option;
            currentAction.percent = parsedAction.percent;
          }
          if (currentAction.field === 'competitorFareInfo.rangeBelow') {
            currentAction.value = buildRangeBelowValue(parsedAction.value);
          } else if (currentAction.field === 'competitorFareInfo.classNames') {
            currentAction.value = _.split(parsedAction.value, ',');
          } else if (isUserInputtedCriteriaType(parsedAction, currentActionCriteriaTypeConfig)) {
            currentAction.criteriaType = getObjectFromValue(availableValues, parsedAction.value);
          } else if (!currentAction.criteriaType) {
            currentAction.value = getObjectFromValue(availableValues, parsedAction.value);
          }
        } else if (currentAction) {
          if (currentActionCriteriaTypeConfig && currentActionCriteriaTypeConfig.userInputted) {
            setActionValue(currentAction, undefined, parsedAction);
          } else {
            setActionValue(currentAction, availableValues, parsedAction);
          }
        }
        _.pull(actionFields, parsedAction.property);
        if (currentAction && _.isEmpty(actionFields)) {
          var strategy = createStrategyAction(level, entityType, parsedAction, currentAction);
          deserializedActions.push(strategy);
          currentAction = null;
          currentActionCriteriaTypeConfig = null;
        }
      }
    });
    deserializedActions = _.flatten(deserializedActions);
    return deserializedActions;
  }
  return {
    parse: parse,
    serialize: serialize,
    deserialize: deserialize
  };
};
ActionSerializerService.$inject = ['StrategyRecordService', 'ActionQueryFactory', 'StrategyActionFactory', 'StrategyConstants'];
module.exports = ActionSerializerService;